import React from "react";

interface Props {
  show: boolean;
  text?: string;
}

const EmptyMessageWarning: React.FC<Props> = ({
  show,
  text = "Warning: No response was generated for this call. Try adjusting your prompt and parameters.",
}) => {
  if (!show) return null;

  return (
    <span className="mb-1 flex items-center rounded py-1 text-sm italic text-gray-500">
      <svg
        className="mr-2 h-4 w-4 flex-shrink-0 text-yellow-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          fill="currentColor"
          d="M12 2c-.38 0-.73.21-.9.55l-9 17A1 1 0 0 0 3 21h18a1 1 0 0 0 .9-1.45l-9-17A1 1 0 0 0 12 2zm0 4.3L19.07 19H4.93L12 6.3zm-1 7.2v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0zm1 6a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
        />
      </svg>
      {text}
    </span>
  );
};

export default EmptyMessageWarning;
